import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { AppLayout } from "@/components/layout/AppLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { StatsTab } from "./StatsTab";
import { UsersTab, AdminsTab } from "./UsersTab";
import { PromptsTab } from "./PromptsTab";
import { LinksTab } from "./LinksTab";
import { BannersTab } from "./BannersTab";
import { TextsTab } from "./TextsTab";
import { HubSpotTab } from "./HubSpotTab";
import { PluginTab } from "./PluginTab";

export default function AdminDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (user?.role === "admin") {
      api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    }
  }, [user]);

  if (user && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  return (
    <AppLayout>
      <div className="max-w-6xl mx-auto px-5 py-8">
        <div className="eyebrow text-xs text-orange mb-1">Administration</div>
        <h1 className="headline text-4xl text-navy mb-6">Control Center</h1>
        <Tabs defaultValue="stats">
          <TabsList className="mb-6 flex-wrap h-auto">
            <TabsTrigger value="stats" data-testid="admin-tab-stats">Statistics</TabsTrigger>
            <TabsTrigger value="users" data-testid="admin-tab-users">Accounts</TabsTrigger>
            <TabsTrigger value="admins" data-testid="admin-tab-admins">Admins</TabsTrigger>
            <TabsTrigger value="banners" data-testid="admin-tab-banners">Banners</TabsTrigger>
            <TabsTrigger value="texts" data-testid="admin-tab-texts">Texts</TabsTrigger>
            <TabsTrigger value="prompts" data-testid="admin-tab-prompts">AI Prompts</TabsTrigger>
            <TabsTrigger value="hubspot" data-testid="admin-tab-hubspot">HubSpot</TabsTrigger>
            <TabsTrigger value="links" data-testid="admin-tab-links">Tool Links</TabsTrigger>
            <TabsTrigger value="plugin" data-testid="admin-tab-plugin">WP Plugin</TabsTrigger>
          </TabsList>
          <TabsContent value="stats"><StatsTab stats={stats} /></TabsContent>
          <TabsContent value="users"><UsersTab selfId={user?.id} /></TabsContent>
          <TabsContent value="admins"><AdminsTab selfId={user?.id} /></TabsContent>
          <TabsContent value="banners"><BannersTab /></TabsContent>
          <TabsContent value="texts"><TextsTab /></TabsContent>
          <TabsContent value="prompts"><PromptsTab /></TabsContent>
          <TabsContent value="hubspot"><HubSpotTab /></TabsContent>
          <TabsContent value="links"><LinksTab /></TabsContent>
          <TabsContent value="plugin"><PluginTab /></TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
}
